/**
 * @generated SignedSource<<a98792010c57220fbca28cd0ab033ab9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type SlackIntegrationPrivateChannelsMutation$variables = {
  enabled: boolean;
};
export type SlackIntegrationPrivateChannelsMutation$data = {
  readonly updatePrivateChannelsEnabled: {
    readonly error: {
      readonly message: string;
    } | null | undefined;
    readonly success: {
      readonly organization: {
        readonly id: any;
        readonly privateChannelsEnabled: boolean;
      };
    } | null | undefined;
  };
};
export type SlackIntegrationPrivateChannelsMutation = {
  response: SlackIntegrationPrivateChannelsMutation$data;
  variables: SlackIntegrationPrivateChannelsMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "enabled"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "enabled",
        "variableName": "enabled"
      }
    ],
    "concreteType": "UpdatePrivateChannelsEnabledResponse",
    "kind": "LinkedField",
    "name": "updatePrivateChannelsEnabled",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "UpdatePrivateChannelsEnabledSuccess",
        "kind": "LinkedField",
        "name": "success",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "GraphQLOrganization",
            "kind": "LinkedField",
            "name": "organization",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "privateChannelsEnabled",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "UpdatePrivateChannelsEnabledError",
        "kind": "LinkedField",
        "name": "error",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "message",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SlackIntegrationPrivateChannelsMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SlackIntegrationPrivateChannelsMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "c6764f29e8758a9ac67b5371dfce5cc6",
    "id": null,
    "metadata": {},
    "name": "SlackIntegrationPrivateChannelsMutation",
    "operationKind": "mutation",
    "text": "mutation SlackIntegrationPrivateChannelsMutation(\n  $enabled: Boolean!\n) {\n  updatePrivateChannelsEnabled(enabled: $enabled) {\n    success {\n      organization {\n        id\n        privateChannelsEnabled\n      }\n    }\n    error {\n      message\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "55fe665b115125983e6783723369376d";

export default node;
